import CompanyDocReportsTab from './CompanyDocReportsTab';
import { DialogUI } from '../Interface';

const CompanyDocReportsDialog = ({ disabled, documentTypes, onClose, open, selectedValues, valuesState }) => {
  return (
    <DialogUI open={open} onClose={onClose} headerContent="Bizonylat riportok" maxWidth="md" fullWidth closeBtn>
      <CompanyDocReportsTab
        disabled={disabled}
        documentTypes={documentTypes}
        selectedValues={selectedValues}
        valuesState={valuesState}
      />
    </DialogUI>
  );
};

export default CompanyDocReportsDialog;
